module.exports = __webpack_public_path__ + "img/KinokoTable62.28c635ba.jpg";